var _excluded = ["item"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import React from 'react';
import * as Cards from './presets';
import * as autocompletePropTypes from '../../utils/prop-types';
import { jsx as ___EmotionJSX } from "@emotion/core";
var CardMap = {
  STREET: Cards.StreetCard,
  DIVISION: Cards.DivisionCard,
  DISTRICT: Cards.LocalityCard,
  REGION: Cards.LocalityCard,
  SCHOOL: Cards.SchoolCard,
  ADDRESS: Cards.AddressCard,
  DEVELOPMENT: Cards.DevelopmentCard,
  AGENCY: Cards.AgencyCard,
  AGENT: Cards.AgentCard
};
var OptionCard = _ref => {
  var item = _ref.item,
    props = _objectWithoutProperties(_ref, _excluded);
  var Card = CardMap[item.type] || Cards.LocalityCard;
  return ___EmotionJSX(Card, _extends({
    item: item
  }, props));
};
OptionCard.propTypes = {
  item: autocompletePropTypes.value.isRequired
};
var RecentItemCard = Cards.RecentItemCard;
export default OptionCard;
export { RecentItemCard };